'use client';
import { Dispatch, SetStateAction, useState } from 'react';
import FirstScreen from './FirstScreen';
import SecoundScreen from './SecoundScreen';

const NotifyMe = ({
    setModal,
    carId,
    clearForm = false,
}: {
    setModal: Dispatch<SetStateAction<boolean>>;
    carId: string;
    clearForm?: boolean;
}) => {
    const [activeScreen, setActiveScreen] = useState(0);

    return activeScreen === 0 ? (
        <FirstScreen
            setModal={setModal}
            carId={carId}
            nextStep={setActiveScreen}
            clearForm={clearForm}
        />
    ) : (
        <SecoundScreen setModal={setModal} />
    );
};

export default NotifyMe;
